import React from 'react'

const STEM_TIME_OPTIONS = [
	{ value: '5', label: '5 min' },
	{ value: '15', label: '15 min' },
	{ value: '30', label: '30 min' },
	{ value: '45', label: '45 min' },
	{ value: '60', label: '1 hour' },
	{ value: '90', label: '1.5 hours' },
	{ value: '120', label: '2 hours' },
	{ value: '150', label: '2.5 hours' },
	{ value: '180', label: '3 hours' },
	{ value: '240', label: '4 hours' },
]

function StemTimeSelect({
	value,
	onChange,
	disabled = false,
	isDarkMode = false,
}) {
	return (
		<div className="text-center py-1">
			<select
				value={value}
				onChange={onChange}
				disabled={disabled}
				className={`
					w-20 h-6 text-center text-[10px] font-medium border border-gray-300 rounded px-1 cursor-pointer
					${
						isDarkMode
							? 'text-white bg-gray-700 border-gray-600'
							: 'text-gray-900 bg-white'
					}
					${disabled ? 'opacity-50 cursor-not-allowed' : ''}
				`}
				style={{
					paddingTop: '1px',
					paddingBottom: '1px',
					lineHeight: '1',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				{STEM_TIME_OPTIONS.map(option => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
			<div
				className={`text-xs font-medium tracking-wide mt-1 ${
					isDarkMode ? 'text-gray-400' : 'text-gray-400'
				}`}
			>
				Stem Time
			</div>
		</div>
	)
}

export default StemTimeSelect
